import { APP_INITIALIZER, enableProdMode, importProvidersFrom } from '@angular/core';
import './dayjs-setup';
import { environment } from './environments/environment';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { DayjsDateAdapter } from './app/dayjs-date-adapter';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TokenInterceptor } from './app/core/interceptors/token-interceptor';
import { AuthenticationService } from './app/core/services/authentication/authentication.service';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { provideApiConfiguration } from './app/core/api/api-configuration';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'DD MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'DD MMMM YYYY',
  },
};

function AppServiceFactory(authSrv: AuthenticationService) {
  return () => authSrv.init();
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(APP_ROUTES),
        provideAnimations(),
        importProvidersFrom(
            FontAwesomeModule,
            TranslateModule.forRoot({
                defaultLanguage: 'ua',
                useDefaultLang: true,
                loader: {
                    provide: TranslateLoader,
                    useClass: TranslateHttpLoader
                }
            }),
        ),
        { provide: DateAdapter, useClass: DayjsDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        { provide: APP_INITIALIZER, useFactory: AppServiceFactory, multi: true, deps: [AuthenticationService] },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
        { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: { pageSize: 50 } },
        provideApiConfiguration(environment.host),
        provideHttpClient(withInterceptorsFromDi()),
        provideCharts(withDefaultRegisterables()),
        ...provideTranslateHttpLoader()
    ]
})
  .catch(err => console.error(err));
